// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__2lOvj"};